import { keyframes, styled } from '../../config'
import { Loading } from '../../icons'

const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
})

export const Spinner = styled(Loading, {
  animation: `${spin} 2s linear infinite`,
  variants: {
    size: {
      sm: { width: '16px', height: '16px', strokeWidth: '1px' },
      md: { width: '24px', height: '24px', strokeWidth: '1.5px' },
      lg: { width: '32px', height: '32px', strokeWidth: '2px' }
    }
  }
})
